module.exports = __webpack_public_path__ + "img/华杰资信  @2x.09726353.png";